module.exports = "<span>&copy; {{settings.app.year}} - {{ settings.app.description }}</span>"